// Aligns the "Quantity" box to the Add to Basket button by its bottom
// edge only: the input/select's bottom lands exactly on the button's
// bottom (never its box-shadow - getBoundingClientRect() never includes
// that). The label is left at its own natural height above the box, which
// is intentionally taller than forcing it to also start level with the
// button's top - the label + box together are naturally taller than the
// button, so the label ends up peeking above the button's top edge rather
// than being squeezed down to start level with it.
(function () {
    function findMetaRoot(el) {
        var node = el;
        while (node && node !== document.body) {
            if (node.classList && node.classList.contains('#product-meta')) {
                return node;
            }
            node = node.parentElement;
        }
        return document;
    }

    // The main "Add to Basket" button carries data-to-cart, but so does the
    // small "Add to basket" button on an optional gift/add-on inside the
    // per-product promo box (#product-promo) - both use the same generic
    // marker. Skip any match that lives inside a promo box so this always
    // lands on the real button, regardless of which block order the
    // merchant has set up.
    function findMainButton(root) {
        var candidates = root.querySelectorAll('[data-to-cart]');
        for (var i = 0; i < candidates.length; i++) {
            if (!candidates[i].closest('.\\#product-promo')) {
                return candidates[i];
            }
        }
        return null;
    }

    function align() {
        var boxes = document.getElementsByClassName('#product-qty-selector');

        for (var i = 0; i < boxes.length; i++) {
            var box = boxes[i];
            var root = findMetaRoot(box);
            var button = findMainButton(root);
            if (!button) continue;

            // Clear any previous override before measuring the box's
            // natural (unshifted) position and height.
            box.style.marginTop = '0px';

            var boxRect = box.getBoundingClientRect();
            var buttonRect = button.getBoundingClientRect();

            if (!buttonRect.height || !boxRect.height) continue; // not laid out yet

            // The quantity block and the button sit in the same flex-wrap
            // row on wider screens, side by side, which is what this
            // bottom-alignment is for. On narrow screens (mobile) they
            // don't both fit on one line, so the quantity block wraps onto
            // its own row above the button - at that point "align my
            // bottom with the button's bottom" means "push down until
            // level with a button that's a whole row further down the
            // page", which is exactly the huge empty gap this used to
            // leave on mobile. Only apply the override while the two are
            // actually still side by side (their rows overlap vertically);
            // otherwise leave the CSS fallback margin alone.
            var sameRow = boxRect.top < buttonRect.bottom && buttonRect.top < boxRect.bottom;
            if (!sameRow) {
                box.style.marginTop = '';
                continue;
            }

            var naturalBottom = boxRect.top + boxRect.height;
            var delta = buttonRect.bottom - naturalBottom;
            box.style.marginTop = delta + 'px';
        }
    }

    var requestAlign = function () {
        requestAnimationFrame(align);
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', requestAlign);
    } else {
        requestAlign();
    }
    // Fonts loading in late, or the theme editor re-rendering the section,
    // can change either element's size after the first pass.
    window.addEventListener('load', requestAlign);
    window.addEventListener('resize', requestAlign);
    document.addEventListener('shopify:section:load', requestAlign);
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(requestAlign);
    }
})();
